import React from "react";

export default function Error() {
  return <h1>hello form error page</h1>;
}
